import { render, staticRenderFns } from "./LivingOptionsMasterplan.vue?vue&type=template&id=0982524c"
import script from "./LivingOptionsMasterplan.vue?vue&type=script&lang=js"
export * from "./LivingOptionsMasterplan.vue?vue&type=script&lang=js"
import style0 from "./LivingOptionsMasterplan.vue?vue&type=style&index=0&id=0982524c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports